module.exports = __webpack_public_path__ + "static/media/templates.1c857c49.svg";